<template>
  <div class="clients">
    <span id="c-add-up">
      <ClientAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('clients.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#c-add-up"
        />
      </template>
      <div class="row">
        <div class="flex md12">
          <va-input
            v-model="name"
            :label="$t('clients.forms.nameLabel')"
            :placeholder="$t('clients.forms.namePlaceholder')"
          />
          <div class="form-group mb-3">
            <va-select
              :label="$t('clients.forms.statusPlanoLabel')"
              v-model="status"
              textBy="name"
              keyBy='id'
              no-clear
              :placeholder="$t('clients.forms.statusPlanoPlaceholder')"
              :noOptionsText="$t('clients.forms.statusPlanoNoOption')"
              maxHeight='200px'
              :options="optionsStatus"
            />
          </div>
        </div>
      </div>
      <va-data-table
        :fields="fields"
        :data="clients"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('clients.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#c-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover v-if="props.rowData.id != loggedUserId" :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData.id)"
            />
          </va-popover>
        </template>
        <template slot="photo" slot-scope="props">
          <div class="d-flex justify-content-center img-logo">
            <img :src="props.rowData.photo !== null ?
              $store.getters['environment/cdn'] + '/photo-client/' + props.rowData.photo :
              $store.getters['environment/cdn'] + '/photo-client/profile-image.png'"/>
          </div>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('clients.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ClientAddUpdate from './ClientAddUpdate'

const perPage = 20
export default {
  name: 'clients',
  components: {
    ClientAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (id) {
      this.modalDeletar = true
      this.deleteId = id
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.clients.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_client_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      loggedUserId: this.$store.getters['authenticate/user'].id,
      clients: [],
      name: '',
      optionsStatus: [
        {
          id: 3, name: 'Todas Situações',
        },
        {
          id: 1, name: 'Plano Ativos',
        },
        {
          id: 2, name: 'Sem Plano Ativo',
        },
      ],
      status: {
        id: 3, name: 'Todas Situações',
      },
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    clients: {
      query: gql`
        query MyQuery($page: Int = 0, $perPage: Int = 100, $busca: String = "%%", $sit: Int) {
          clients: filter_client(args: {metodo: $sit}, limit: $perPage, offset: $page, where: {_and: [{_or: [{fullName: {_ilike: $busca}}, {email: {_ilike: $busca}}]}]}, order_by: {id: desc}) {
            id
            firstName
            lastName
            email
            since
            photo
            cp: contracted_plans(where: {active: {_eq: true}}) {
              id
              plan {
                name
              }
              date_final
            }
            club {
              id
              name
            }
            partner {
              name
            }
            points
          }
        }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          busca: this.nameSearch,
          sit: this.status.id,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($busca: String = "%%", $sit: Int) {
        pages: filter_client_aggregate(args: {metodo: $sit}, where: {_and: [{_or: [{fullName: {_ilike: $busca}}, {email: {_ilike: $busca}}]}]}) {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        return {
          busca: this.nameSearch,
          sit: this.status.id,
        }
      },
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    nameSearch () {
      return '%' + this.name.trim() + '%'
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      },
      {
        name: '__slot:photo',
        title: this.$t('clients.headings.photo'),
      },
      {
        name: 'firstName',
        title: this.$t('clients.headings.name'),
        width: '25%',
      },
      {
        name: 'email',
        title: this.$t('clients.headings.email'),
        width: '25%',
      },
      {
        name: 'points',
        title: this.$t('clients.headings.points'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      },
      {
        name: 'cp',
        title: this.$t('clients.headings.plan'),
        width: '5%',
        callback (value) {
          return value.length > 0 ? value[0].plan.name : ''
        },
      },
      {
        name: 'cp',
        title: this.$t('clients.headings.final'),
        width: '5%',
        callback (value) {
          return value.length > 0 ? moment(value[0].date_final).format('DD/MM/YYYY') : ''
        },
      },
      {
        name: 'club',
        title: this.$t('clients.headings.club'),
        width: '10%',
        callback (value) {
          return value ? value.name : ''
        },
      }, {
        name: 'since',
        title: this.$t('clients.headings.since'),
        width: '10%',
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: 'partner',
        title: this.$t('clients.headings.partner'),
        width: '10%',
        callback (value) {
          return value != null ? value.name : ''
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('clients')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.clients.refetch()
    }
  },
}
</script>

<style lang="scss" scoped>
.img-logo img {
  width: 5rem;
  border-radius: 50%;
}
</style>
